site.endeca.result.product = jQuery.extend( true, {}, site.endeca.result.product, {
  initialize: function( args ) {
        this._super( args );
        if ( this.resultData.MISC_FLAG == 1 ) {
          this.resultData.MISC_FLAG_TEXT = rb.endeca.misc_flag_new;
        }
    },
  });